export default {"src":"/_next/static/media/facebook-icon.2cdf12c6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};